import React from 'react';
import { Box, HStack, pickColor, Text } from 'remodeling-web-mobile-sdk-ui';

const SearchZoneCodeNoti = () => {
  return (
    <Box px="20px">
      <Text as="p" variant="subTitle1" mb={16}>
        아래와 같은 방법으로 검색해 보세요.
      </Text>
      <HStack mb="8px">
        <Box
          width="2px"
          height="2px"
          backgroundColor={pickColor('accent_color.primary.default')}
          mr="4px"
        ></Box>
        <Text
          variant="body3"
          color={pickColor('accent_color.primary.default')}
          mr="8px"
        >
          도로명+건물 번호
        </Text>
        <Text variant="body3" color={pickColor('natural_color.gray.600')}>
          예: 성암로 179, 방배로 285
        </Text>
      </HStack>
      <HStack mb="8px">
        <Box
          width="2px"
          height="2px"
          backgroundColor={pickColor('accent_color.primary.default')}
          mr="4px"
        ></Box>
        <Text
          variant="body3"
          color={pickColor('accent_color.primary.default')}
          mr="8px"
        >
          지역명(동/리)+번지
        </Text>
        <Text variant="body3" color={pickColor('natural_color.gray.600')}>
          예: 상암동 1623, 방배동 757
        </Text>
      </HStack>
      <HStack>
        <Box
          width="2px"
          height="2px"
          backgroundColor={pickColor('accent_color.primary.default')}
          mr="4px"
        ></Box>
        <Text
          variant="body3"
          color={pickColor('accent_color.primary.default')}
          mr="8px"
        >
          지역명(동/리)+건물명(아파트명)
        </Text>
        <Text variant="body3" color={pickColor('natural_color.gray.600')}>
          예: 방배동 한샘
        </Text>
      </HStack>
    </Box>
  );
};

export default SearchZoneCodeNoti;
